export const fixed =
  'M128.22,3.73A124.41,124.41,0,0,0,3.73,128.22c0,68.38,55.67,124.05,124.49,124.05,68.38,0,124.05-55.67,124.05-124C252.27,59.4,196.6,3.73,128.22,3.73ZM177,85.62H107.51v34h60V144h-60v61.09h-29V61.3H177Z'
